// extracted by mini-css-extract-plugin
module.exports = {"Value":"Value--IwKzO"};